import {
  Button,
  Divider,
  Layout,
  Row,
  Table,
  Tag,
  Tooltip,
  Breadcrumb,
  PageHeader,
  Spin,
} from "antd";
import axios from "axios";
import moment from "moment";
import React, { Component } from "react";
import Moment from "react-moment";
import { connect } from "react-redux";
import { Constant } from "../../config";
import { fetchMenuAction } from "../../store/actions/leftSideMenu";
import MyModal from "../Modal";
import Search from "./search";

const { Content } = Layout;
Moment.globalLocal = false;
const ButtonGroup = Button.Group;

// 20230515 Sorarat:modify code from User/index.js
class ApproveBinding extends Component {
  state = {
    data: [],
    pagination: {},
    loading: false,
    saleBindingList: [],

    filter: {},
  };

  columns = [
    {
      title: "Create Date",
      dataIndex: "created",
      key: "created",
      render: (_, record) => {
        const convertedDate = this._convertTimestamp(record.created.Time);
        return <span>{convertedDate}</span>;
      },
      align: "center",
    },
    {
      title: "Account Aging",
      dateIndex: "accountAge",
      key: "account-aging",
      render: (_, record) => {
        return <span>{record.account_aging || "-"}</span>;
      },
      align: "center",
    },
    {
      title: "Channel",
      dateIndex: "channel",
      key: "channel",
      render: (_, record) => {
        return <span>{record.channel || "-"}</span>;
      },
      align: "center",
    },
    {
      title: "Customer Name", // customername
      dataIndex: "firstname",
      key: "customername",
      render: (_, record) => {
        return <span>{record.member.Firstname || "-"}</span>;
      },
      align: "center",
    },
    {
      title: "Contact",
      dataIndex: "tel",
      key: "contact",
      render: (text, record) => {
        return (
          <span>
            {record.member.Email || "-"}
          </span>
        );
      },
      align: "center",
    },
    {
      title: "Current Owner",
      dataIndex: "currentowner",
      key: "currentowner",
      render: (text, record) => {
        return (
          <span>
            {record.sale_owner.Firstname || "-"}
          </span>
        );
      },
      align: "center",
    },
    {
      title: "Request By",
      dataIndex: "requestby",
      key: "requestby",
      render: (text, record) => {
        return (
          <span>
            {record.requested_by.Firstname || "-"}
          </span>
        );
      },
      align: "center",
    },
    {
      title: "Note",
      dataIndex: "note",
      key: "note",
      width: 20,
      render: (text, record) => {
        const maxLength = 38;
        const truncatedText = record.note.String ? (record.note.String.length > maxLength ? record.note.String.substring(0, maxLength) + "..." : record.note.String) : "-";
        return (
          <Tooltip placement="topLeft" title={record.note.String}>
            <span style={{ cursor: 'pointer' }}>{truncatedText}</span>
          </Tooltip>
        );
      },
      align: "center",
    },
    // เผื่ออยากให้แสดง column status
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   render: (text, record) => {

    //     let badge = "orange"
    //     let statusTxt = "Waiting for approve"
    //     if (text === "approved") {
    //       badge = "green"
    //       statusTxt = "Approved"
    //     } else if (text === "reject") {
    //       badge = "red"
    //       statusTxt = "Rejected"
    //     }
    //     return (
    //       <span>
    //         <div><Tag color={badge} style={{marginRight: '0px'}}>{statusTxt}</Tag></div>
    //       </span>
    //     );
    //   },
    //   align: "center",
    // },
    {
      title: "Action",
      key: "action",
      dataIndex: "id",
      render: (text, record) => {
        const isPending = record.status === "to_approved"

        let badge = "orange"
        let statusTxt = "Waiting for approve"
        if (record.status === "approved") {
          badge = "green"
          statusTxt = "Approved"
        } else if (record.status === "reject") {
          badge = "red"
          statusTxt = "Rejected"
        }
        return (
          <div style={{ textAlign: "right" }}>
            {isPending ? <div><ButtonGroup>
              <Tooltip placement="top" title="Approve">
                <Button type="primary" icon="check" onClick={() => this.approve(record)} />
              </Tooltip>
              <Tooltip placement="top" title="Reject">
                <Button type="danger" icon="close" onClick={() => this.reject(record)} />
              </Tooltip>
            </ButtonGroup></div> :  <div><Tag color={badge} style={{marginRight: '0px'}}>{statusTxt}</Tag></div>}
          </div>
        );
      },
      align: "center",
    },
  ];
  columnsMobile = [
    {
      title: "",
      dataIndex: "firstname",
      key: "firstname",
      render: (text, record) => {
        const isPending = record.status === "to_approved"

        let badge = "orange"
        let statusTxt = "Waiting for approve"
        if (record.status === "approved") {
          badge = "green"
          statusTxt = "Approved"
        } else if (record.status === "reject") {
          badge = "red"
          statusTxt = "Rejected"
        }
        return (
          <span>
            <Divider className="my-divider" dashed orientation="left">
              Account Aging
            </Divider>
            <div>
                {record.account_aging || "-"}
            </div>
            <Divider className="my-divider" dashed orientation="left">
              Channel
            </Divider>
            <div>
              {record.channel || "-"}
            </div>
            <Divider className="my-divider" dashed orientation="left">
              Name
            </Divider>
            <div>
              {record.member.Firstname || "-"}
            </div>

            <Divider className="my-divider" dashed orientation="left">
              Contact
            </Divider>
            <div>
              {record.member.Email || "-"}
            </div>
            <Divider className="my-divider" dashed orientation="left">
              Current Owner
            </Divider>
            <div>
              {record.sale_owner.Firstname || "-"}
            </div>
            <Divider className="my-divider" dashed orientation="left">
              Request by
            </Divider>
            <div>
              {record.requested_by.Firstname || "-"}
            </div>
            <Divider className="my-divider" dashed orientation="left">
              Note
            </Divider>
            <div>
              {record.note.String || "-"}
            </div>
            <Divider className="my-divider" dashed orientation="left"></Divider>
            <Row>

            <div>
            {isPending ? <div><ButtonGroup>
                <Tooltip placement="top" title="Approve">
                  <Button type="primary" icon="check" onClick={() => this.approve(record)} />
                </Tooltip>
                <Tooltip placement="top" title="Reject">
                  <Button type="danger" icon="close" onClick={() => this.reject(record)} />
                </Tooltip>
              </ButtonGroup></div> :  <div><Tag color={badge} style={{marginRight: '0px'}}>{statusTxt}</Tag></div>}
            </div>
              <Divider type="vertical" />

            </Row>
          </span>
        );
      },
    },
  ];

  componentWillMount() { // edit ตรงนี้ left side bar จะมีสีฟ้่า
    this.props.fetchMenuAction("approve-binding-sales-owner", "approve-binding-sales-owner");
    this.setState({ loading: true });
  }

  async componentDidMount() {
    this.setState({
      loading: false,
    });

    await this.getListBindingRequest();
  }

  handleTableChange = (pagination) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    this.getListBindingRequest(pager.current, pagination.pageSize, this.state.filter);
  };

  getListBindingRequest = async (
    page = 1,
    limit = 10,
    filter = { "channel": "", "aging":"", "requested_by": 0, "action": "", "sale_owner": 0 } //ค่า default
  ) => {
    let url = Constant.SALES_BINDING_API;
    for (const key in filter) {
      if (!filter[key]) {
        delete filter[key];
      }
    }
    url += `?search=${JSON.stringify(filter)};`
    const options = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
      params: {
        page,
        limit,
      },
    };
    let resp;

    try {
      resp = await axios(options);
    } catch (err) {
      resp = err.response;
    }


    let pagination = { ...this.state.pagination };
    pagination.size = "small";
    let d = [];

  
    if (!resp.data) {
      console.log(resp.data);
    } else if (resp.data.error) {
      console.log(resp.data.error);
    } else {
      d = resp.data.data;
      pagination.total = resp.data.total_rows; // change total to total_rows แก้เลขหน้าได้แล้ว :)
    }


    this.setState({
      loading: false,
      data: d,
      pagination,
    });
  };
  handleSearch = (values) => {
    const pagination = this.state.pagination;
    pagination.current = 1;
    this.setState({
      pagination,
      filter: values,
    });
    this.getListBindingRequest(1, 10, values);
  };

  handleClear = () => {
    const pagination = this.state.pagination;
    pagination.current = 1;
    this.setState({ pagination });
    this.getListBindingRequest();
  };


  // add new
  _convertTimestamp = (timestamp) => {
    const formattedDate = moment.utc(timestamp).format('DD/MM/YYYY HH:mm');
    return formattedDate;
  };

  reject = (record) => {
    MyModal.confirm("Reject Binding Request?", "", async (f) => {
      if (!f)
        return

      this.setState({ loading: true })

      let opt = {
        url: Constant.SALES_BINDING_API + `/${record.id}`,
        method: "PATCH",
        headers: {
          'Authorization': "Bearer " + localStorage.getItem(Constant.SessionKey)
        },
        data: {
          status: 'reject'
        }
      }
      let resp
      let eMsg = `Something went wrong. Please try again.`
      let eMsgDetail = ""
      let eFlag = false

      try {
        resp = await axios(opt)
      } catch (err) {
        resp = err.response
      }

      if (!resp.data) {
      } else if (resp.data.error) {
        eFlag = true
        let e = resp.data.error
        eMsgDetail = `[${e.code}] ${e.name}`
      }

      if (eFlag) { // reload when error
        MyModal.error(eMsg, eMsgDetail, () => {
          window.location.reload()
        })
      } else {
        MyModal.info(`Binding Request has been rejected successfully.`, "", async () => {
          this.setState({
            loading: false,
            dataSource: await this.getListBindingRequest()
          })
        })
      }
    }, "Yes", "No")
  }

  approve = (record) => {
    MyModal.confirm("approved Binding Request?", "", async (f) => {
      if (!f)
        return

      this.setState({ loading: true })

      let opt = {
        url: Constant.SALES_BINDING_API + `/${record.id}`,
        method: "PATCH",
        headers: {
          'Authorization': "Bearer " + localStorage.getItem(Constant.SessionKey)
        },
        data: {
          member_id: record.member_id,
          channel: record.channel,
          status: 'approved',
          sale_owner_id: record.sale_owner.Id
        }
      }
      let resp
      let eMsg = `Something went wrong. Please try again.`
      let eMsgDetail = ""
      let eFlag = false


      try {
        resp = await axios(opt)
      } catch (err) {
        resp = err.response
      }

      if (!resp.data) {
      } else if (resp.data.error) {
        eFlag = true
        let e = resp.data.error
        eMsgDetail = `[${e.code}] ${e.name}`
      }

      if (eFlag) { // reload when error
        MyModal.error(eMsg, eMsgDetail, () => {
          window.location.reload()
        })
      } else {
        MyModal.info(`Binding Request has been approved successfully.`, "", async () => {
          this.setState({
            loading: false,
            dataSource: await this.getListBindingRequest()
          })
        })
      }
    }, "Yes", "No")
  }

  render() {
    let propsTable = {
      className: "my-table",
      columns: this.columns,
      dataSource: this.state.data,
      rowKey: (record) => record.id, //?
      pagination: this.state.pagination,
      loading: this.state.loading,
      onChange: this.handleTableChange,
    };
    let propsTableForMobile = Object.assign({}, propsTable);
    propsTableForMobile.className = "my-table-mobile";
    propsTableForMobile.columns = this.columnsMobile;

    return ( //JSX here
      <Layout>
        <Breadcrumb className="breadcrumb">
          <Breadcrumb.Item>Approve Binding Sales Owner</Breadcrumb.Item>
        </Breadcrumb>
        <PageHeader
          style={{
            backgroundColor: "#f0f2f5",
          }}
          title={<h2 style={{ fontWeight: "bold" }}>Approve Binding Sales Owner</h2>}
        />
        <Layout className="my-layout">
          <Content className="main-container" >
            <div className="main-container-inner">
              <Search
                onSearch={this.handleSearch}
                onClear={this.handleClear}
              />
            </div>
            <Spin spinning={this.state.loading}> 
              <Table scroll={{ x: "max-content" }} {...propsTable} />
              <Table {...propsTableForMobile} />
            </Spin>
          </Content>
        </Layout>
      </Layout>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
  };
};

export default connect(null, mapDispatchToProps)(ApproveBinding);



// WEBPACK FOOTER //
// ./src/containers/ApproveBinding/index.js